//
// Generated class Invoice
//

/// <reference path="Invoice_ManagedObject.ts" />

class Invoice extends Invoice_ManagedObject
{
    // Not stored. What the detail view found while the invoice is being prepared (a line without
    // product or VAT, detected lines still to add, lines that do not add up to the total read), so
    // the stripe of the list cell shows the same colour as the detail's status line. Null until a
    // detail view has looked at the invoice (the list then goes by the document's reading state).
    reviewHasIssues:boolean = null;

    get sectionDateString(): string {
        if (this.date == null) return null;
        
        let m = (this.date.getMonth() + 1).toString();
        let y = this.date.getFullYear();

        return y + "-" + (m[1]?m:"0" + m[0]);
    }

    get monthString():string {
        if (this.date == null) return null;        
        let m = this.date.getMonth();        
        return MIODateGetStringForMonth(m);
    }
}
